
import moment from 'moment';
import * as arcService from '@/services/arc-api.service'
import vuei18n from '@/plugins/vue-i18n';
export default {
    sponsorFormFields: (state) => state.newAuthorization.sponsorForm,
    sponsorFormMethod: (state) => state.newAuthorization.beneficiarySearch.formSlug,
    authorizations: (state) => {
        return state.authorizations.map(authorization => {
            return {
                authorizationCode: authorization.authorizationCode,
                code: authorization.id,
                createdAt: moment(authorization.createdAt).format('DD/MM/YYYY'),
                sponsor: authorization.sponsorName,
                beneficiary: authorization.beneficiaryName,
                memberCode: authorization.beneficiaryMemberCode,
                providerBranchName: authorization.providerBranchName,
                authorizationType: vuei18n.t(arcService.getType(authorization)),
                status: vuei18n.t(arcService.getStatus({authorizationStatus: authorization.claimStatus})),
                statusSlug: authorization.claimStatus,
                satisfiesDocumentsPolicy: authorization.satisfiesDocumentsPolicy,
                sponsorTransactionId: authorization.sponsorTransactionId,
                uploadedFiles: authorization.uploadedFiles,
                totalFilesToUpload: authorization.totalFilesToUpload,
                authorizationId: authorization.authorizationId,
                isRequiredExternalSponsorValidations: authorization.isRequiredExternalSponsorValidations,
                isVoidable: arcService.providerClaimAuthorizationIsVoidable(authorization)
            }
        })
    },
    loadingAuthorizations: (state) => state.loadingAuthorizations,
    authorizationPage: (state) => {
        const { page } = state;
        return { ...page, number: page.number + 1 }
    },
    beneficiaries: (state) => {
        if(state.beneficiaries.content){
            return state.beneficiaries.content.map(beneficiary => {
                return {
                    name: beneficiary.name.toLowerCase(),
                    birth: moment(beneficiary.dateOfBirth).format('DD/MM/YYYY'),
                    identification: beneficiary.identityDocumentId,
                    owner: beneficiary.owner,
                    sex: beneficiary.sex === 'MALE' ? 'beneficiaryResults.male' : 'beneficiaryResults.female',
                    id: beneficiary.id,
                    age: beneficiary.age,
                    status: beneficiary.status
                }
            })
        }else{
            return []
        }
    },
    beneficiariesTotalResults: (state) => state.beneficiaries.page ? state.beneficiaries.page.totalElements : 0,
    isTypeSelected: (state) => state.newAuthorization.steps.type,
    isSponsorSelected: (state) => state.newAuthorization.steps.sponsor,
    isMethodSelected: (state) => state.newAuthorization.steps.method,
    isBeneficiarySelected: (state) => state.newAuthorization.steps.beneficiary,
    isBeneficiarySearchComplete: (state) => state.newAuthorization.steps.beneficiarySearchComplete,
    beneficiary: (state) => state.beneficiary,
    beneficiaryError: (state) => state.beneficiaryError,
    beneficiarySelected: (state) => state.beneficiarySelected,
    beneficiarySearchError: (state) => state.errorAlert,
    authorizationFormValues: (state) => state.authorizationFormValues,
    isBiometricVerified: (state) => state.authorizationFormValues.isVerified,
    loadingVerification: (state) => state.loadingVerification,
    authorizationTypeSelected: (state) => state.newAuthorization.type,
    navBarType: (state) => state.newAuthorization.type ? state.newAuthorization.type.navBarText : "",
    authorizationResult: (state) => state.authorizationResult,
    loadingCreateClaim: (state) => state.loadingCreateClaim,
    getAuthorizationDetailHeader: (state) => state.authorizationDetail.header,
    getAuthorizationDetail: (state) => {
        let detail = state.authorizationDetail.detail;
        const products = detail.products && detail.products
            .map(product => ({
                ...product,
                refill: product.refillNumber !== null ? vuei18n.t("authorizationDetail.products.headers.refillValues", {refillNumber: product.refillNumber, numberOfRefills: product.numberOfRefills}) : ''
            })) || []

        return {
            id: detail.id,
            beneficiaryId: detail.beneficiaryId,
            sponsorSlug: detail.sponsorSlug,
            sponsorTransactionId: detail.sponsorTransactionId,
            amount: arcService.sanitizeAmount('',detail.amount,false),
            copayment: arcService.sanitizeAmount('',detail.copayment,false),
            medicalLicenseNumber: detail.doctorMedicalLicenseNumber,
            doctorCountryCode: detail.doctorCountryCode,
            doctorSpecialty: detail.doctorSpecialtyName,
            doctorName: detail.doctorName,
            providerTransactionId: detail.providerTransactionId,
            biometricReadingId: detail.biometricReadingId,
            diagnoses: detail.diagnoses,
            products: detail.transactionType === "OUTPATIENT_CARE" ? [] : products,
            status: vuei18n.t(arcService.getStatus({authorizationStatus: detail.status})),
            statusSlug: arcService.getStatus({authorizationStatus: detail.status}),
            beneficiaryName: detail.beneficiaryName,
            beneficiaryMemberCode: detail.beneficiaryMemberCode,
            sponsorName: detail.sponsorName,
            transactionType: vuei18n.t(arcService.getType(detail)),
            transactionTypeRaw: detail.transactionType,
            productType: detail.productType,
            settlementId: detail.settlementId,
            currencyCode: detail.currencyCode,
            files: detail.files,
            satisfiesDocumentsPolicy: detail.satisfiesDocumentPolicy,
            authorizationId: detail.authorizationId,
            authorizationRequestId: detail.authorizationRequestId,
            isVoidable: arcService.providerClaimAuthorizationIsVoidable(detail),
            treatments: detail.treatments &&
                detail.treatments.map(treatment => ({
                    ...treatment,
                    drug: treatment.brand.concat(' ', treatment.composition),
                    treatment: treatment.indication && treatment.indication.join(',') || ''
                }))
                || []
        }
    },
    dialogAuthorizationFilesAttach: (state) => state.dialogAuthorizationFilesAttach,
    actualStep: (state) => state.newAuthorization.actualStep,
    createClaimError: (state) => state.createClaimError,
    doctorFields: (state) => state.authorizationFormValues.doctorFields,
    prescriptionCreated: (state) => state.prescription,
    prescriptionProducts: (state) => {
        const authorizations = state.prescription ? state.prescription.authorizations : [];
        const dispensationProducts = state.dispensation ? state.dispensation.cosharings.products : [];
        let productList = [];
        if(authorizations){
            authorizations.map(authorization => {
                if(authorization.products){
                    authorization.products.map(product => productList.push({
                        id: product.id,
                        productId: product.productId,
                        productName: arcService.osgCapitalize(product.productName),
                        productTypeSlug: product.productTypeSlug,
                        quantity: product.quantity,
                        status: product.status,
                        reason: product.reason,
                        subtotal: "0.00"
                    }))
                }
            })

            if(productList.length > 0){
                if(dispensationProducts){
                    if(dispensationProducts.length > 0){
                        productList.map(product => {
                            dispensationProducts.map(dispensingProduct => {
                                if(product.id === dispensingProduct.id){
                                    product.subtotal = dispensingProduct.price
                                }
                            })
                        })
                    }
                }
            }

            return productList
        }else{
            return []
        }
    },
    getAuthorizationDetailSponsorProduct: (state) => state.authorizationDetail.sponsorProduct.productName,
    getProviderProducts: (state) => {
        return state.newAuthorization.providerProducts.map(product => {
            return {
                text: product.productName,
                value: product.providerProductCode
            }
        })
    },
    getSponsorProducts: (state) => {
        return state.newAuthorization.providerProducts.map(product => {
            return {
                text: product.productName,
                value: `${product.sponsorProductCode}-${product.productName}`,
                sponsorProductCode: product.sponsorProductCode
            }
        })
    },
    getedCosharings: (state) => state.dispensation.cosharings && Object.keys(state.dispensation.cosharings).length === 0 ? false : true,
    cosharingAmounts: (state) => state.dispensation.cosharings ? state.dispensation.cosharings : {},
    loadingDispensation: (state) => state.dispensation.loading.general,
    creatingDispensation: (state) => state.dispensation.loading.creation,
    dispensationResult: (state) => state.dispensation.dispensationResult,
    startDispensationError: (state) => state.dispensation.error && Object.keys(state.dispensation.error).length > 0,
    startDispensationErrorMessages: (state) => state.dispensation.error,
    getSponsors: (state) => {
        return state.newAuthorization.sponsors.map(sponsor => {
            if(sponsor){
                return {
                    value: sponsor.slug,
                    text: vuei18n.t(arcService.getSponsorText(sponsor.slug)) || sponsor.name,
                    categories: arcService.getSponsorCategories(sponsor.slug),
                    biometricVerificationRequired: sponsor.biometricVerificationRequired,
                    biometricVerificationMethod: sponsor.biometricVerificationMethod
                }
            }
        })
    },
    getProviderProductType: (state) => {
        const typesConfiguration = arcService.authorizationTypes;
        const providerTypes = state.newAuthorization.providerProductTypes;
        const authorizedTypes = typesConfiguration.filter(types => providerTypes.includes(types.transactionType))
        return authorizedTypes.map(type => {
            let activeTypeValue = false;
            if(state.newAuthorization.type){
                const selectedTransactionType = state.newAuthorization.type.transactionType
                const selectedProductType = state.newAuthorization.type.productType
                activeTypeValue = selectedTransactionType === type.transactionType && selectedProductType === type.productType 
            }
            return {
                active: activeTypeValue,
                value: {...type}
            }
        })
    },
    getBiometricVerificationRequired: (state) => state.newAuthorization.biometricVerificationRequired,
    sponsorSelectedInAuthorizationCreation: (state) => state.newAuthorization.beneficiarySearch.sponsorSlug,
    selectedSponsorSlug: (state) => state.newAuthorization.beneficiarySearch.sponsorSlug,
    sponsorDocumentPolicy: (state) => state.newAuthorization.sponsorDocumentPolicy,
    providerName: (state) => state.providerName,
    biometricVerificationMethod: (state) => state.biometricVerificationMethod,
    isAllowBeneficiaryDataUpdate: (state) => state.newAuthorization.beneficiarySearch.isAllowBeneficiaryDataUpdate,
    getSponsorsProvider: (state) => state.sponsorsProvider
}
